import { useQuery } from '@tanstack/vue-query'
import { organizationKeys } from './keys'
import type { OrganizationDetail } from '~/types/Organization'
import { OrganizationService } from '~/services/api/organization/organization'

// Resolve a single org by slug (GET /organizations/by-slug/:slug). The
// super-user fallback for the current-org lookup: an org a super user is viewing
// but does not belong to is absent from GET /users/me, so it can't come from the
// membership store. `enabled` is expected to gate this to super users who lack
// the org in their memberships, so it never fires for regular users.
export function useOrganizationBySlugQuery(
  slug: MaybeRefOrGetter<string>,
  enabled?: MaybeRefOrGetter<boolean>,
) {
  const organizationService = new OrganizationService()

  return useQuery({
    queryKey: computed(() => organizationKeys.bySlug(toValue(slug))),
    queryFn: async (): Promise<OrganizationDetail> =>
      unwrapOrThrow(
        await organizationService.getOrganizationBySlug(toValue(slug)),
      ),
    enabled: computed(
      () => (toValue(enabled) ?? true) && Boolean(toValue(slug)),
    ),
    staleTime: 5 * 60 * 1000,
  })
}
